// extracted by mini-css-extract-plugin
export var completionBody = "_f9-2";
export var completionCard = "_f9-0";
export var completionFooter = "_f9-3";
export var completionTitle = "_f9-1";